import { render, staticRenderFns } from "./ColAdminUserList.vue?vue&type=template&id=52da1c86"
import script from "./ColAdminUserList.vue?vue&type=script&lang=js"
export * from "./ColAdminUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports